export const clientTypes = {
  // Dashboard type
  GET_USER_DATA_PENDING: "GET_USER_DATA_PENDING",
  GET_USER_DATA_SUCCESS: "GET_USER_DATA_SUCCESS",
  GET_USER_DATA_FAILED: "GET_USER_DATA_FAILED",

  GET_USER_ACTIVITY_DATA_PENDING: "GET_USER_ACTIVITY_DATA_PENDING",
  GET_USER_ACTIVITY_DATA_SUCCESS: "GET_USER_ACTIVITY_DATA_SUCCESS",
  GET_USER_ACTIVITY_DATA_FAILED: "GET_USER_ACTIVITY_DATA_FAILED",

  GET_USER_DETAIL_DATA_PENDING: "GET_USER_DETAIL_DATA_PENDING",
  GET_USER_DETAIL_DATA_SUCCESS: "GET_USER_DETAIL_DATA_SUCCESS",
  GET_USER_DETAIL_DATA_FAILED: "GET_USER_DETAIL_DATA_FAILED",

  GET_USER_ACTIVITY_PENDING: "GET_USER_ACTIVITY_PENDING",
  GET_USER_ACTIVITY_SUCCESS: "GET_USER_ACTIVITY_SUCCESS",
  GET_USER_ACTIVITY_FAILED: "GET_USER_ACTIVITY_FAILED",

  GET_USER_CATEGORY_PENDING: "GET_USER_CATEGORY_PENDING",
  GET_USER_CATEGORY_SUCCESS: "GET_USER_CATEGORY_SUCCESS",
  GET_USER_CATEGORY_FAILED: "GET_USER_CATEGORY_FAILED",

  GET_ADV_DATA_PENDING: "GET_ADV_DATA_PENDING",
  GET_ADV_DATA_SUCCESS: "GET_ADV_DATA_SUCCESS",
  GET_ADV_DATA_FAILED: "GET_ADV_DATA_FAILED",

  GET_BRANDING_DATA_PENDING: "GET_BRANDING_DATA_PENDING",
  GET_BRANDING_DATA_SUCCESS: "GET_BRANDING_DATA_SUCCESS",
  GET_BRANDING_DATA_FAILED: "GET_BRANDING_DATA_FAILED",

  GET_ADV_DETAILS_DATA_PENDING: "GET_ADV_DETAILS_DATA_PENDING",
  GET_ADV_DETAILS_DATA_SUCCESS: "GET_ADV_DETAILS_DATA_SUCCESS",
  GET_ADV_DETAILS_DATA_FAILED: "GET_ADV_DETAILS_DATA_FAILED",

  GET_PODCAST_DATA_PENDING: "GET_PODCAST_DATA_PENDING",
  GET_PODCAST_DATA_SUCCESS: "GET_PODCAST_DATA_SUCCESS",
  GET_PODCAST_DATA_FAILED: "GET_PODCAST_DATA_FAILED",

  GET_PODCAST_DETAILS_DATA_PENDING: "GET_PODCAST_DETAILS_DATA_PENDING",
  GET_PODCAST_DETAILS_DATA_SUCCESS: "GET_PODCAST_DETAILS_DATA_SUCCESS",
  GET_PODCAST_DETAILS_DATA_FAILED: "GET_PODCAST_DETAILS_DATA_FAILED",

  GET_PROFILE_DATA_PENDING: "GET_PROFILE_DATA_PENDING",
  GET_PROFILE_DATA_SUCCESS: "GET_PROFILE_DATA_SUCCESS",
  GET_PROFILE_DATA_FAILED: "GET_PROFILE_DATA_FAILED",

  GET_CMS_DATA_PENDING: "GET_CMS_DATA_PENDING",
  GET_CMS_DATA_SUCCESS: "GET_CMS_DATA_SUCCESS",
  GET_CMS_DATA_FAILED: "GET_CMS_DATA_FAILED",

  DASHBOARD_DATA_PENDING: "DASHBOARD_DATA_PENDING",
  DASHBOARD_DATA_SUCCESS: "DASHBOARD_DATA_SUCCESS",
  DASHBOARD_DATA_FAILED: "DASHBOARD_DATA_FAILED",
};
